(ns frontend.view.modals.opportunity-stage-delete.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.actions.opportunity-stages :as opportunity-stage-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.modals.components.processing-modal :as processing-modal]
   [ui.color :as c]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]
   [ui.editors.data-input :as data-input]))

(defonce modal-key :opportunity-stage-delete-modal)

(defn update!
  [state k val]
  (swap! state assoc-in [:edit k] val))

(defn select-opportunity-stage-view
  [state opportunity-stage]
  (let [pipeline-id (:opportunity-stage/pipeline opportunity-stage)
        opportunity-stages (->> @session/opportunity-stages
                                (remove (fn [s]
                                          (= s opportunity-stage)))
                                (cu/filter-by :opportunity-stage/pipeline pipeline-id)
                                (sort-by :common/ord))
        value (get-in @state [:edit :new-opportunity-stage])
        error (when (and (:touched? @state)
                         (fu/empty-value? value))
                (loc/tr :mandatory-field/value-not-set [(loc/tr :stage)]))]
    [:div
     [data-input/view
      {:editor-type   :editor.type/select
       :data-type     :data.type/ref-single
       :is-clearable? false
       :full-width?   true
       :value         value
       :error         error
       :options       (->> opportunity-stages
                           (map (fn [a]
                                  {:value (:db/id a)
                                   :label (entity/display-string a)})))
       :on-blur       (fn [_] (swap! state assoc :touched? true))
       :on-change     (fn [new-value & _]
                        (swap! state assoc :touched? true)
                        (update! state :new-opportunity-stage new-value))}]
     (when error
       [:p {:class "text-xs text-danger-light-text"} error])]))

(defn view-body
  [state opportunity-stage-id]
  (let [opportunity-stage (get @session/entities opportunity-stage-id)
        reassignment-required? (:reassignment/required? @state)]
    [:div
     {:class "flex flex-col gap-4"}
     (when reassignment-required?
       [:div
        {:class "flex flex-col gap-4"}
        [:span {:class "font-semibold"}
         (loc/tr :opportunity-stage-select-new
                 [(:reassignment/count @state)
                  (:opportunity-stage/name opportunity-stage)])]
        [select-opportunity-stage-view state opportunity-stage]])
     [:label
      {:class "inline-flex flex items-center gap-2 cursor-pointer"}
      [checkbox/view
       {:value  (-> @state
                    :confirmed?
                    boolean)
        :on-change #(swap! state update :confirmed? not)}]
      [:span
       (loc/tr :i-understand-theres-no-undo-for-this)]]]))

(defn handle-delete-error!
  [state e]
  (if (= :stage-reassignment-required
         (get-in e [:client-friendly-error-data :reason]))
    (swap! state (fn [s]
                   (-> s
                       (assoc :reassignment/required? true)
                       (assoc :reassignment/count
                              (get-in e [:client-friendly-error-data :count]))
                       (dissoc :process/status))))
    (do
      (logging/error "failed to delete opportunity-stage" e)
      (swap! state assoc :process/status :process.status/failed))))

(defn delete!
  [state opportunity-stage-id on-close!]
  (let [new-opportunity-stage-id (-> @state
                                     :edit
                                     :new-opportunity-stage)
        msg (cond-> {:opportunity-stage-id opportunity-stage-id}
              new-opportunity-stage-id
              (assoc :new-opportunity-stage-id new-opportunity-stage-id))]
    (swap! state assoc :process/status :process.status/processing)
    (opportunity-stage-actions/*->disable
     msg
     (fn [_]
       (js/setTimeout (fn []
                        (swap! state assoc :process/status :process.status/success))
                      2000))
     (fn [e]
       (handle-delete-error! state e)))))

(defn footer-view
  [{:keys [disabled? state on-close! opportunity-stage]}]
  [:<>
   [modal/left-cancel-only on-close! nil]
   [modal/right-single-button
    ::c/danger
    disabled?
    (fn [_]
      (delete! state (:db/id opportunity-stage) on-close!))
    (loc/tr :delete)
    nil]])

(defn view
  [{:keys [close-modal!] :as view-args}]
  (let [on-close! (fn []
                    (close-modal!))]
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [body opportunity-stage-id]} props
            confirmed? (-> @state
                           :confirmed?
                           boolean)
            new-opportunity-stage (->> @state
                                       :edit
                                       :new-opportunity-stage
                                       (get @session/entities))
            disabled? (or (not confirmed?)
                          (and (:reassignment/required? @state)
                               (or (nil? new-opportunity-stage)
                                   (:common/disabled? new-opportunity-stage))))
            opportunity-stage (get @session/entities opportunity-stage-id)]
        [processing-modal/render-modal
         {:state             state
          :shown?            (and shown? topmost?)
          :success-text      (loc/tr :success-opportunity-stage-deleted)
          :on-close!         on-close!
          :class-name        class-name
          :header-class-name "zap-modal__header__salmon"
          :default-title-fn  #(loc/tr :attention)
          :default-body-fn   (partial view-body state opportunity-stage-id)
          :default-footer-fn (partial footer-view
                                      {:disabled?         disabled?
                                       :state             state
                                       :on-close!         on-close!
                                       :opportunity-stage opportunity-stage})}]))))
